module.exports = __webpack_public_path__ + "logo-prestashop.fec0a6a968bb2efb21884473fd61d21f.png";